import type { ConnectorBindingConfiguration, FormField } from '../types';

export function buildDefaultConnectorBindingConfiguration(
  createField: (value: string) => FormField
): ConnectorBindingConfiguration {
  return {
    parameterDestination: 'project',
    parameterBindingKind: 'type',
    endpoint1Value: createField('PiX_PPG_END1_TYPE'),
    endpoint2Value: createField('PiX_PPG_END2_TYPE'),
    endpoint3Value: createField('PiX_PPG_END3_TYPE'),
    endpoint4Value: createField('PiX_PPG_END4_TYPE'),
    materialValue: createField('PiX_03_Material_ENG'),
    designStdValue: createField('PiX_02_Standard_ENG'),
    pressureClassValue: createField('PiX_PPG_END1_PressureRating'),
    insulationSpecValue: createField('PiX_GN_2_InsulationSpec'),
    insulationThicknessValue: createField('PiX_GN_2_InsulationThickness'),
    weightValue: createField('PiX_06_Mass_kg_Piping'),
    tracingSpecValue: createField('PiX_GN_2_HeatTracingSpec'),
    itemDescriptionValue: createField('PiX_01_Description_ENG'),
  };
}
